import type { ContactCard } from '../fr/contact';

export { LINKEDIN_URL } from '../fr/contact';

export const CONTACT_CARDS: readonly ContactCard[] = [
  {
    id:          'emploi',
    icon:        'Briefcase',
    title:       'A job?',
    body:        'Inspector, quality technician, industrial AI integrator — I am open to the right opportunity.',
    colorVar:    'var(--color-piloter)',
    colorRgbVar: 'var(--color-piloter-rgb)',
  },
  {
    id:          'defi',
    icon:        'Zap',
    title:       'A problem to crack?',
    body:        "Something your ERP does not solve, an inspection that takes too long, data nobody ever reads. Let's talk.",
    colorVar:    'var(--color-temps)',
    colorRgbVar: 'var(--color-temps-rgb)',
  },
  {
    id:          'freelance',
    icon:        'Code2',
    title:       'Freelance work?',
    body:        'Automation, a custom quality app, industrial AI deployment — I take on well-defined mandates.',
    colorVar:    'var(--color-maitrise)',
    colorRgbVar: 'var(--color-maitrise-rgb)',
  },
  {
    id:          'asterion',
    icon:        'Layers',
    title:       'Asterion Solutions?',
    body:        'A demo of one of the applications, a partnership, a custom fit for your shop — happy to discuss it.',
    colorVar:    'var(--color-anticiper)',
    colorRgbVar: 'var(--color-anticiper-rgb)',
  },
];

export const CONTACT_CTA: string = 'Message me on LinkedIn ↗';
export const CONTACT_PLACE: string = 'Quebec, Canada';

export { CV_URL } from '../fr/contact';
export const CONTACT_CV_LABEL: string = 'Download my CV (PDF, French)';
